import {svgIconWrapper} from '../svg-icon-wrapper';

import ComputerMobileRegular from './computer-mobile-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ComputerMobileRegular {...props} />;
}
SvgComponent.iconName = 'computerMobileRegular';

export const ComputerMobileRegularIcon = svgIconWrapper(SvgComponent);
